module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "msgApp"
    }
  }, [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.toMessageManagement()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("\n      返回\n    ")]), _vm._v(" "), _c('h1', {
    staticClass: "title",
    staticStyle: {
      "align-content": "center",
      "font-size": "smaller"
    }
  }, [_vm._v(_vm._s(_vm.Messages.merchantName) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "main",
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('dialoguecontent', {
    attrs: {
      "messages": _vm.Messages.messages
    }
  }), _vm._v(" "), _c('textcontent', {
    attrs: {
      "merchantNo": _vm.Messages.merchantNo,
      "messages": _vm.Messages.messages
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f2e5d18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Message/Message.vue
// module id = 1631
// module chunks = 8